import { useContent } from "@/context/ContentContext";
import { resolveImg } from "@/lib/api";
import { Marquee } from "./Marquee";

const VEIL = "linear-gradient(180deg,rgba(13,13,13,.1) 30%,rgba(13,13,13,.85) 100%)";

export const BleedRoles = () => {
  const { bleed_2: b } = useContent();

  return (
    <section
      className="bleed"
      style={{ minHeight: "min(80vh,760px)", display: "flex", flexDirection: "column", justifyContent: "flex-end" }}
      data-testid="bleed-roles"
    >
      {b?.image_url && <img src={resolveImg(b.image_url)} alt="" />}
      <div className="veil" style={{ background: VEIL }} />
      <Marquee items={b?.roles || []} className="in" style={{ paddingBottom: 36 }} testid="roles-marquee" />
    </section>
  );
};
